import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'initials',
    standalone: false,
    pure: true
})
export class InitialsPipe implements PipeTransform {
  transform(name: string | null | undefined, fallback = 'BA'): string {
    if (!name) {
      return fallback;
    }
    const parts = name.trim().split(' ').filter(part => part.length > 0);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    if (parts.length === 1 && parts[0].length >= 2) {
      return parts[0].substring(0, 2).toUpperCase();
    }
    return fallback;
  }
}
